package org.example.project.game

import kotlinx.serialization.Serializable

/**
 * GameRoom — exakt das App-Datenformat.
 * Felder und Pfade entsprechen 1:1 der Android-MainActivity.createRoom():
 *   rooms/{roomCode}/...
 *
 * Avatar ist ein String wie "avatargreen", "loki", "elephant" — der
 * Drawable-Name aus der App. Der Browser muss dieses String-Format
 * beibehalten, damit die App den Avatar zuordnen kann.
 */
@Serializable
data class GameRoom(
    val roomCode: String = "",
    val gameId: String = "",
    val status: String = "waiting",                    // "waiting" | "playing"
    val lang: String = "DE",
    val difficulty: String = "easy",

    // {playerId: true}
    val players: Map<String, Boolean> = emptyMap(),

    // {playerId: PlayerInfo}
    val playerInfo: Map<String, PlayerInfo> = emptyMap(),

    // {playerId: score}
    val scores: Map<String, Int> = emptyMap(),

    val whosTurn: String = "",

    // pro Zug, jede Aktion 1x erlaubt
    val hintUsed: Boolean = false,
    val jokerUsed: Boolean = false,
    val answerUsed: Boolean = false,

    // {"A1":true, "A2":true, "TIP_B":true, ...}
    val revealedHints: Map<String, Boolean> = emptyMap(),

    // {"A":true, "B":true}
    val solvedColumns: Map<String, Boolean> = emptyMap(),

    // {playerId: true}
    val giveUpVotes: Map<String, Boolean> = emptyMap(),

    // {playerId: true}
    val spectators: Map<String, Boolean> = emptyMap(),

    val winner: String = ""
)

@Serializable
data class PlayerInfo(
    val name: String = "",
    val avatar: String = "avatargreen"   // App-Drawable-Name als String
)